import App, { Container } from "next/app";
import React from "react";
import TopNavigation from "../components/template/TopNavigation";
import BottomNavigation from "../components/template/BottomNavigation";

export default class MyApp extends App {
  static async getInitialProps({ Component, router, ctx }) {
    let pageProps = {};

    if (Component.getInitialProps) {
      pageProps = await Component.getInitialProps(ctx);
    }

    return { pageProps };
  }

  componentDidMount() {
    console.log(this.props);

    console.log(document.location.pathname);

    if (document.location.pathname === "/") {
      window.location.replace("https://unifiedproducts.com");
      // window.location.replace('https://secure1.unified.ph');
      // window.location.replace('https://unified.ph');
    }
  }

  render() {
    const { Component, pageProps } = this.props;

    return (
      <div>
        {this.props.router.asPath == "/ecashpay-kyc" ? (
          <Container>
            <Component {...pageProps} />
          </Container>
        ) : this.props.router.asPath !== "/" ? (
          <Container>
            <TopNavigation />
            <Component {...pageProps} />
            <BottomNavigation />
          </Container>
        ) : null}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// pages/_app.js